import { PUBLIC_IP_API_KEY } from '$env/static/public';

export class LocationService {
  static async getLocationData() {
    // Ensure this only runs in the browser
    if (typeof window === 'undefined') {
      console.warn('Location detection attempted on server side');
      return null;
    }

    // Check if we already have cached location data
    const cachedData = this.getCachedLocationData();
    if (cachedData && cachedData.country && cachedData.countryCode) {
      return {
        success: true,
        data: {
          country: cachedData.country,
          countryCode: cachedData.countryCode,
          message: 'Location data retrieved from cache',
        },
      };
    }

    try {
      //Have to use pro.ip-api.com so we can use HTTPS
      const response = await fetch(
        `https://pro.ip-api.com/json?key=${PUBLIC_IP_API_KEY}&fields=status,message,country,countryCode`,
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`IP-API request failed: ${errorData.error}`);
      }

      const data = await response.json();
      if (data.status === 'success') {
        const locationData = {
          country: data.country,
          countryCode: data.countryCode,
          message: 'Location data retrieved successfully',
        };
        // Store complete data in session storage for caching
        sessionStorage.setItem('userLocation', JSON.stringify(data));
        return {
          success: true,
          data: locationData,
        };
      } else {
        return {
          success: false,
          error: data.message || 'Failed to get location data',
        };
      }
    } catch (error) {
      return {
        success: false,
        error: `Failed to connect to IP-API, ${error}`,
      };
    }
  }

  /**
   * Get cached location data from sessionStorage
   * @returns {Object|null} Cached location data or null
   */
  static getCachedLocationData() {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const cached = sessionStorage.getItem('userLocation');
      return cached ? JSON.parse(cached) : null;
    }
    return null;
  }

  /**
   * Clear cached location data
   */
  static clearCachedLocationData() {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.removeItem('userLocation');
    }
  }
}
